import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// -------------------------------------------------------------------------
// 共通
// -------------------------------------------------------------------------
(function() {
    // スクロールバーの幅計算
    function scrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    let lastResize = 0; // Encapsulated variable

    function setScrollbarWidth() {
        const width = scrollbarWidth();
        if (width > 0) {
            document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
        }
    }

    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

    if (!isTouchDevice && scrollbarWidth() > 0) {
        window.addEventListener('load', setScrollbarWidth);
        window.addEventListener('resize', () => {
            if (Date.now() - (lastResize || 0) > 100) {
                setScrollbarWidth();
                lastResize = Date.now();
            }
        });
    }
})();

window.addEventListener('load', () => {
    ScrollTrigger.refresh();
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 500);
});
